import axios from 'axios';

export const User = {
  fetch: () => axios.get('/users'),
  create: user => axios.post('/users', user),
  delete: id => axios.delete(`/users/${id}`),
  geodisLogin: params => axios.get('/users/geodisLogin', { params }),
  bulkDelete: emails => axios.post('/users/bulkDelete', emails),
};

export const Mpo = {
  get: params => axios.get('/mpo/get', { params }),
  events: params => axios.get('/mpo/events', { params }),
  infoEvents: () => Promise.resolve({ }),
  contents: () => Promise.resolve({ }),
  documents: params => axios.get('/mpo/documents', { params }),
  downloadDocument: params => axios.get('/mpo/downloaddocument', { params }),
  search: params => axios.get('/mpo/search', { params }),
};

export const Zenith = {
  get: params => axios.get('/zenith/get', { params }),
  events: params => axios.get('/zenith/events', { params }),
  infoEvents: params => axios.get('/zenith/infoevents', { params }),
  contents: params => axios.get('/zenith/contents', { params }),
  documents: params => axios.get('/zenith/documents', { params }),
  downloadDocument: params => axios.get('/zenith/downloaddocument', { params, responseType: 'blob' }),
  search: params => axios.get('/zenith/search', { params }),
};

export const Share = {
  generate: params => axios.get('/share/generate', { params }),
};

export const Scope = {
  fetch: params => axios.get('/scope', { params }),
  create: scope => axios.post('/scope', scope),
  update: scope => axios.put('/scope', scope),
  find: scope => axios.get(`/scope/${scope}`),
  delete: scope => axios.delete(`/scope/${scope}`),
  systems: () => axios.get('/scope/systems'),
};

export const Setup = {
  fetch: params => axios.get('/setup', { params }),
  update: setup => axios.put('/setup', setup),
  create: (scope, setup) => axios.post(`/setup/${scope}`, setup),
  delete: (scope, setup) => axios.delete(`/setup/${scope}/${setup}`),
};

export const Geocoding = {
  get: (query, params, baseURL) => axios.get(query, { params, baseURL }),
};

export const Menu = {
  fetch: params => axios.get('/menus', { params }),
  create: menu => axios.post('/menus', menu),
  update: menu => axios.put('/menus', menu),
  order: menus => axios.put('/menus/order', menus),
  find: menu => axios.get(`/menus/${menu}`),
  delete: menu => axios.delete(`/menus/${menu}`),
};

export const Permission = {
  fetch: params => axios.get('/permissions/', { params }),
  me: email => axios.post(
    '/permissions/me',
    `"${email}"`,
    { headers: { 'Content-Type': 'application/json' } },
  ),
  group: (email, params) => axios.post(
    '/groups/permissions/me',
    `"${email}"`,
    {
      headers: { 'Content-Type': 'application/json' },
      params,
    },
  ),
  create: permission => axios.post('/permissions/', permission),
  update: permission => axios.put('/permissions/', permission),
  find: permission => axios.get(`/permissions/${permission}`),
  delete: permission => axios.delete(`/permissions/${permission}`),
};

export const Groups = {
  fetch: params => axios.get('/groups', { params }),
  create: group => axios.post('/groups', group),
  update: group => axios.put('/groups', group),
  permissions: (group, ids) => axios.put(`/groups/${group}/permission`, ids),
  delete: group => axios.delete(`/groups/${group}`),
  updateMany: groups => axios.put('/groups/many', groups),
};

export const GDPR = {
  fetch: params => axios.get('/gdpr/', { params }),
  create: gdpr => axios.post('/gdpr/', gdpr),
  update: gdpr => axios.put('/gdpr/', gdpr),
  find: gdpr => axios.get(`/gdpr/${gdpr}`),
  delete: gdpr => axios.delete(`/gdpr/${gdpr}`),
  send: gdpr => axios.post('/Email/send/', gdpr),
};

export const Auth = {
  me: params => axios.get('/auth/exists', params),
  fetch: token => axios.post('/auth/getauthorization', {}, { headers: { Authorization: `Bearer ${token}` } }),
  token: () => axios.get('/auth/token'),
  logout: () => axios.get('/auth/logout'),
  validateEmail: params => axios.get('/auth/EmailExists', params),
};

export const Docs = {
  getLibrary: params => axios.get('/sharepoint/getlibrary', { params }),
  getLibraryChildren: params => axios.get('/sharepoint/getlibrarychildren', { params }),
  downloadFile: params => axios.get('/sharepoint/downloadfile', { params, responseType: 'blob' }),
};

export const Reports = {
  fetch: params => axios.get('/reports/fetch', { params }),
  download: params => axios.get('/reports/download', { params }),
};

export const Iot = {
  hits: params => axios.get('/iot/hits', { params }),
};

export const Logs = {
  fetch: () => (
    !window.ENV.system.logging
      ? Promise.resolve({ data: [] })
      : axios.get('/logs')
  ),
  send: text => (
    !window.ENV.system.logging
      ? Promise.resolve(true)
      : axios.post('/logs', text)
  ),
  download: (params, options) => (
    !window.ENV.system.logging
      ? Promise.resolve({ data: [] })
      : axios.get('/logs/download', { params, options })
  ),
};
